import React from 'react';
import { Card, HideOnMobile, HideOnTablet } from 'quanta-ui';
import PolicySummaryPanelFire from './policy-summary-details';

export default function SummaryPanelFire({
  proposal_no,
  policy_no,
  customer_id,
  lobProductList,
  forwardedCoversFormRef,
}) {
  return (
    <div className="flex flex-col justify-start h-auto sticky top-0">
      <HideOnMobile className="w-full">
        <HideOnTablet className="w-full">
          <Card
            className={`h-full xl:h-auto p-0 m-0 sticky top-0`}
            title="Insurance Summary"
          >
            <PolicySummaryPanelFire
              forwardedCoversFormRef={forwardedCoversFormRef}
              proposal_no={proposal_no}
              policy_no={policy_no}
              customer_id={customer_id}
              lobProductList={lobProductList}
            />
          </Card>
        </HideOnTablet>
      </HideOnMobile>
      <div className="xl:hidden w-full">
        <PolicySummaryPanelFire
          forwardedCoversFormRef={forwardedCoversFormRef}
          proposal_no={proposal_no}
          policy_no={policy_no}
          customer_id={customer_id}
          lobProductList={lobProductList}
        />
      </div>
    </div>
  );
}
